import create from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
export const useVariantsStore = create()(devtools(immer((set) => ({
    variants: [],
    attributes: [],
    selectedValues: [],
    selectedQuantity: 1,
    set: ({ variants, attributes }) => {
        set((state) => {
            state.variants = variants;
            state.attributes = attributes;
            state.selectedVariant = undefined;
            // state.selectedValues = [];
            const searchParams = new URLSearchParams(window.location.search);
            for (const [key, value] of searchParams) {
                if (key.startsWith("attrs")) {
                    const attrId = parseInt(key.replace("attrs[", "").replace("]", ""));
                    const attribute = attributes.find(attribute => attribute.id === attrId);
                    if (attribute) {
                        const attributeValue = attribute.values.find(val => val.id === parseInt(value));
                        if (attributeValue) {
                            state.selectedValues.push({ attribute: attribute, value: attributeValue });
                        }
                    }
                }
            }
            // remove bad selected values
            if (state.selectedValues.length > 0) {
                state.attributes.forEach(attribute => {
                    const index = state.selectedValues.findIndex(selectedValue => selectedValue.attribute.id === attribute.id &&
                        attribute.values.findIndex(value => value.id === selectedValue.value.id) === -1);
                    if (index >= 0) {
                        state.selectedValues.splice(index, 1);
                    }
                });
            }
            // select first variant
            if (variants[0]) {
                // state.selectedVariant = variants[0];
                // state.selectedQuantity =
                //     variants[0].quantity > 0 ? 1 : 0;
                variants[0].values.forEach((variantValue) => {
                    const attribute = attributes.find((attribute) => attribute.id === variantValue.attribute_id);
                    const value = attribute?.values.find((value) => value.id === variantValue.id);
                    if (attribute && value) {
                        const alreadyExists = state.selectedValues.find(val => val.attribute.id === attribute.id);
                        if (!alreadyExists) {
                            state.selectedValues.push({ attribute, value });
                        }
                    }
                });
                state.selectedVariant = state.findSelectedVariant(state);
                state.selectedQuantity =
                    state.selectedVariant?.quantity > 0 ? 1 : 0;
            }
        });
    },
    reset: () => {
        set((state) => {
            state.variants = [];
            state.attributes = [];
            state.selectedVariant = undefined;
            state.selectedValues = [];
            state.selectedQuantity = 1;
        });
    },
    updateSelectedValue: (value) => {
        set((state) => {
            const selectedValue = state.selectedValues.find((selectedValue) => selectedValue.attribute.id === value.attribute.id);
            if (selectedValue) {
                selectedValue.value = value.value;
            }
            else {
                state.selectedValues.push(value);
            }
            const newSelectedVariant = state.findSelectedVariant(state);
            state.selectedVariant = newSelectedVariant;
            state.selectedQuantity =
                newSelectedVariant?.quantity ?? 0 > 0 ? 1 : 0;
        });
    },
    findSelectedVariant: (state) => {
        return state.variants.find((variant) => {
            return variant.values.every((variantValue) => {
                return state.selectedValues.some((selectedValue) => {
                    return (selectedValue.attribute.id ===
                        variantValue.attribute_id &&
                        selectedValue.value.id ===
                            variantValue.id);
                });
            });
        });
    },
    setSelectedQuantity: (quantity) => {
        set((state) => {
            state.selectedQuantity = quantity;
        });
    },
}))));
